export const TEMPLATE_EDIT_START = 'templateForm/templateForm-start';
export const TEMPLATE_EDIT_SUCCESS = 'templateForm/templateForm-success';
export const TEMPLATE_EDIT_ERROR = 'templateForm/templateForm-error';
export const TEMPLATE_EDIT_CLEAR = 'templateForm/templateForm-clear';

export const TEMPLATE_EDIT_SAVE_SUCCESS =
  'templateForm/templateForm-update-success';
